import React from "react";
import { FaSpinner } from "react-icons/fa";
import { useUserAuth } from "../hook/useAuth";
import { Header } from "../components/Navigation/Header/main";

const Logout = () => {
  const { Logout } = useUserAuth();

  const logout = Logout();

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-gray-100">
      <Header />
      <div className="flex items-center justify-center flex-grow p-4">
        {logout.isLoading ? (
          <p className="flex justify-center items-center">
            <FaSpinner className="animate-spin mr-2" /> logout...
          </p>
        ) : (
          <p className="flex justify-center items-center">
            <FaSpinner className="animate-spin mr-2" /> logout...
          </p>
        )}
      </div>
    </div>
  );
};

export default Logout;
